<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabItems = document.querySelectorAll(".tab-content-item");

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      // Remove 'active' from all buttons and contents
      tabButtons.forEach((b) => b.classList.remove("active"));
      tabItems.forEach((item) => item.classList.remove("active"));

      // Swapped logic: clicking tab1 opens tab2, clicking tab2 opens tab1
      if (btn.id === "tab1") {
        document.querySelector(".tab-content-item.tab2").classList.add("active");
        document.getElementById("tab2").classList.add("active");
      } else {
        document.querySelector(".tab-content-item.tab1").classList.add("active");
        document.getElementById("tab1").classList.add("active");
      }
    });
  });
});
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
